export var loadCssDesign = function (css_id, css_json, CONSTANTS_REQ) {
    var element = document.getElementById(css_id);
    if (element != null) {
        if (css_json != null) {
            var css_1 = JSON.parse(css_json);
            if (css_1 != null) {
                Object.keys(css_1).forEach(function (key) {
                    if (key.includes('background-color')) {
                        element.style.setProperty('--' + key.split('-')[0] + '-background-image', 'none');
                        element.style.setProperty('--' + key, css_1[key]);
                    }
                    else if (key.includes('image')) {
                        var imagePath = CONSTANTS_REQ.STATIC + 0 + encodeURI(css_1[key].file_path);
                        element.style.setProperty('--' + key, 'url(' + imagePath + ')');
                    }
                    else {
                        element.style.setProperty('--' + key, css_1[key]);
                    }
                });
            }
        }
    }
    else {
        console.log('ne postoji');
    }
};
//# sourceMappingURL=Utils.js.map